import 'reset-css';
import '../styles/style.scss';

import $ from 'jquery';
import {debounce} from 'throttle-debounce';
import 'slick-carousel';
import GLightbox from 'glightbox';

import '../img/dkm_theme_preview.png';
import '../img/google-maps-marker-icon.png';
import '../img/mdkl-logo.svg';
import '../img/to-top-btn.svg';
import ConsentManagement from "./lib/ConsentManagement";
import ExhibitionSlider from "./lib/ExhibitionSlider";

if (process.env.NODE_ENV !== 'production') {
    console.log('Looks like we are in development mode!');
}

const googleMap = {
    elementId: 'google-map',
    center: {
        lat: 51.329034,
        lng: 12.343661
    },
    zoom: 18,
    marker: {
        position: {
            lat: 51.329034,
            lng: 12.343661
        },
        title: 'Museum für Druckkunst Leipzig',
        icon: {
            image: 'files/dkm/img/google-maps-marker-icon.png',
            width: 140,
            height: 140
        }
    },
    styles: [{
        "featureType": "landscape.natural.landcover",
        "stylers": [{"gamma": 0.44}, {"hue": "#2bff00"}]
    }, {
        "featureType": "water",
        "stylers": [{"hue": "#00a1ff"}, {"saturation": 29}, {"gamma": 0.74}]
    }, {
        "featureType": "landscape.natural.terrain",
        "stylers": [{"hue": "#00ff00"}, {"saturation": 54}, {"lightness": -51}, {"gamma": 0.4}]
    }, {
        "featureType": "transit.line",
        "stylers": [{"gamma": 0.27}, {"hue": "#0077ff"}, {"saturation": -91}, {"lightness": 36}]
    }, {
        "featureType": "landscape.man_made",
        "stylers": [{"saturation": 10}, {"lightness": -23}, {"hue": "#0099ff"}, {"gamma": 0.71}]
    }, {
        "featureType": "poi.business",
        "stylers": [{"hue": "#0055ff"}, {"saturation": 9}, {"lightness": -46}, {"gamma": 1.05}]
    }, {"featureType": "administrative.country", "stylers": [{"gamma": 0.99}]}, {
        "featureType": "administrative.province",
        "stylers": [{"lightness": 36}, {"saturation": -54}, {"gamma": 0.76}]
    }, {
        "featureType": "administrative.locality",
        "stylers": [{"lightness": 33}, {"saturation": -61}, {"gamma": 1.21}]
    }, {
        "featureType": "administrative.neighborhood",
        "stylers": [{"hue": "#ff0000"}, {"gamma": 2.44}]
    }, {
        "featureType": "road.highway.controlled_access",
        "stylers": [{"hue": "#ff0000"}, {"lightness": 67}, {"saturation": -40}]
    }, {
        "featureType": "road.arterial",
        "stylers": [{"hue": "#ff6600"}, {"saturation": 52}, {"gamma": 0.64}]
    }, {
        "featureType": "road.local",
        "stylers": [{"hue": "#006eff"}, {"gamma": 0.46}, {"saturation": -3}, {"lightness": -10}]
    }, {
        "featureType": "transit.line",
        "stylers": [{"hue": "#0077ff"}, {"saturation": -46}, {"gamma": 0.58}]
    }, {"featureType": "transit.station", "stylers": [{"gamma": 0.8}]}, {
        "featureType": "transit.station.rail",
        "stylers": [{"hue": "#ff0000"}, {"saturation": -45}, {"gamma": 0.9}]
    }, {"elementType": "labels.text.fill", "stylers": [{"gamma": 0.58}]}, {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [{"gamma": 2.01}, {"hue": "#00ffff"}, {"lightness": 22}]
    }, {
        "featureType": "transit",
        "stylers": [{"saturation": -87}, {"lightness": 44}, {"gamma": 1.98}, {"visibility": "off"}]
    }, {
        "featureType": "poi.business",
        "elementType": "labels.text",
        "stylers": [{"gamma": 0.06}, {"visibility": "off"}]
    }, {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [{"hue": "#00aaff"}, {"lightness": -6}, {"gamma": 2.21}]
    }, {"elementType": "labels.text.stroke", "stylers": [{"gamma": 3.84}]}, {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [{"visibility": "off"}]
    }, {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [{"gamma": 9.99}]
    }, {
        "featureType": "administrative", "stylers": [{"gamma": 0.01}]
    }]
};
const breakpoints = {
    xs: 320,
    s: 768,
    m: 1000,
    l: 1200
};
let $scrollToTopBtn;

window.onResize = () => {
    if (process.env.NODE_ENV !== 'production') {
        // console.log("onResize triggered");
    }
    setLeftBarHeight();
    moveNavigationInDom();
    moveSearchBtnInDom();
    moveGlobalLinksInDom();
    horizontallyCenterToggleMenuBtn();
    fixMenuLayerProblem();
    setVideoHeight();
}

function onDocumentScroll() {
    $scrollToTopBtn = $('#scroll-to-top-btn');

    if ($(document).scrollTop() > 100) {
        $scrollToTopBtn.fadeIn(200);
    } else {
        $scrollToTopBtn.fadeOut(200);
    }
}

window.onScrollToTopBtnClicked = () => {
    $('html, body').animate({"scrollTop": "0px"}, 300);
}

window.setLeftBarHeight = () => {
    var viewportDimensions = {
            width: $(window).outerWidth(),
            height: $(window).outerHeight()
        },
        $leftBar = $('#left'),
        $menuWrapper = $('#main-navigation'),
        $toggleMenuWrapper = $('#toggle-menu-wrapper'),
        $logo = $('#dkm-logo'),
        $globalLinks = $('#global-links-btns'),
        leftBarContentHeight;

    if (viewportDimensions.width >= breakpoints.l) {
        leftBarContentHeight = $menuWrapper.outerHeight() + $logo.outerHeight() + $globalLinks.outerHeight()
    } else if (viewportDimensions.width > breakpoints.s) {
        leftBarContentHeight = $toggleMenuWrapper.outerHeight() + $logo.outerHeight() + $globalLinks.outerHeight();
    } else {
        leftBarContentHeight = 'auto';
    }

    if (viewportDimensions.height > leftBarContentHeight) {
        $leftBar.height(viewportDimensions.height);
    } else {
        $leftBar.height(leftBarContentHeight);
    }
}

window.horizontallyCenterToggleMenuBtn = () => {
    var viewportDimensions = {
            width: $(window).outerWidth(),
            height: $(window).outerHeight()
        },
        $toggleMenuWrapper = $('#toggle-menu-wrapper'),
        $logo = $('#dkm-logo');

    if (viewportDimensions.width > breakpoints.s && viewportDimensions.width <= breakpoints.l) {
        var marginTop = (viewportDimensions.height - $toggleMenuWrapper.outerHeight()) / 2 - $logo.outerHeight();
        $toggleMenuWrapper.css('marginTop', marginTop);
    } else if (viewportDimensions.width <= breakpoints.s) {
        $toggleMenuWrapper.css('marginTop', 0);
    }
}

window.moveSocialShareToBottomOfParentElement = () => {
    var $socialShare = $('#social-share-btns');

    $socialShare.appendTo($socialShare.parent());
}

window.moveGlobalLinksInDom = () => {
    var viewportDimensions = {
        width: $(window).outerWidth(),
        height: $(window).outerHeight()
    };

    var $mainNavigation = $('.mod_navigation .level_1'),
        $leftBar = $('#left'),
        $globalLinks = $('#global-links-btns');

    if (viewportDimensions.width <= breakpoints.s) {
        $globalLinks.appendTo($mainNavigation);
    } else {
        $globalLinks.appendTo($leftBar);
    }
}

window.moveNavigationInDom = () => {
    var viewportDimensions = {
        width: $(window).outerWidth(),
        height: $(window).outerHeight()
    };

    var $mainContent = $('#main'),
        $leftBar = $('#left'),
        $menuWrapper = $('#main-navigation');

    if (viewportDimensions.width <= breakpoints.l) {
        $menuWrapper.css('height', $(document).outerHeight()).appendTo($mainContent);
    } else {
        $menuWrapper.css('height', 'auto').appendTo($leftBar);
    }
}

window.moveSearchBtnInDom = () => {
    var viewportDimensions = {
        width: $(window).outerWidth(),
        height: $(window).outerHeight()
    };

    var $navLeft = $('.mod_navigation .level_1'),
        $leftBar = $('#left'),
        $searchBtn = $('div.search-btn');

    if (viewportDimensions.width <= breakpoints.s) {
        $searchBtn.appendTo($leftBar);
    } else {
        $searchBtn.appendTo($navLeft);
    }
}

window.bindNavigationEvents = () => {
    /**
     * desktop submenu handling
     */
    var $submenuToggle = $('.submenu-toggle'),
        viewportDimensions = {
            width: $(window).outerWidth(),
            height: $(window).outerHeight()
        };

    $submenuToggle.click(function (e) {
        e.preventDefault();

        var $submenu = $(this).parent().find('.level_2'),
            self = this;

        if (!$submenu.is(':visible')) {
            $submenu.slideDown(200, function () {
                $(self).toggleClass('open');

                if (viewportDimensions.width > breakpoints.l) {
                    $(window).trigger('resize');
                }
            });
        } else {
            $submenu.slideUp(200, function () {
                $(self).toggleClass('open');

                if (viewportDimensions.width > breakpoints.l) {
                    $(window).trigger('resize');
                }
            });
        }
    });

    /**
     * mobile menu handling
     */
    var $menuWrapper = $('#main-navigation');
    $('.toggle-menu-btn').click(function () {
        $('.toggle-menu-btn').toggleClass('open');
        $menuWrapper.toggleClass('open');
        $(window).scrollTop(0);

        fixMenuLayerProblem();
    });
}

/**
 * bugfix: set z-index temporary
 */
window.fixMenuLayerProblem = () => {
    var viewportDimensions = {
            width: $(window).outerWidth(),
            height: $(window).outerHeight()
        },
        $menuWrapper = $('#main-navigation');

    if (viewportDimensions.width <= breakpoints.s && $menuWrapper.hasClass('open')) {
        $('#main').css('z-index', 100);
    } else {
        $('#main').css('z-index', 10);
    }
}

window.setVideoHeight = () => {
    var $videos = $('.ce_youtube').find('iframe');
    // console.log($videos);
    $videos.each(function () {
        var $video = $(this);
        $video.css('height', $video.outerWidth() * 9 / 16);
    });
}

/**
 * called async via Google Maps API callback
 */
window.initializeGoogleMap = () => {
    if (document.getElementById(googleMap.elementId) === null) {
        return false;
    }

    var mapOptions = {
        zoom: googleMap.zoom,
        center: new google.maps.LatLng(googleMap.center.lat, googleMap.center.lng),
        scrollwheel: false,
        styles: googleMap.styles
    };

    var map = new google.maps.Map(document.getElementById(googleMap.elementId), mapOptions);
    var image = new google.maps.MarkerImage(
        googleMap.marker.icon.image,
        new google.maps.Size(googleMap.marker.icon.width, googleMap.marker.icon.height)
    );

    var marker = new google.maps.Marker({
        position: new google.maps.LatLng(googleMap.marker.position.lat, googleMap.marker.position.lng),
        map: map,
        icon: image
    });
}

/**
 * event list filters
 */

window.initEventFilters = () => {
    window.$eventListWrapper = $('.event-list-filtered');
    window.$eventFilterTime = $('#event-filter-time');
    window.$eventFilterCalendar = $('#event-filter-calendar');
    window.eventFilterTimeValue = null;
    window.eventFilterCalendarValue = null;

    buildEventList();

    window.$eventFilterTime.on('change', onEventFilterChanged);
    window.$eventFilterCalendar.on('change', onEventFilterChanged);

    window.$eventFilterTime.trigger('change');
}

window.buildEventList = () => {
    var events = $eventListWrapper.find('.event'),
        eventList = [];

    $.each(events, function () {
        eventList.push({
            ref: $(this),
            calendar: parseInt($(this).data('calendar')),
            timeStart: parseInt($(this).data('time-start')),
            timeEnd: parseInt($(this).data('time-end'))
        });
    });

    window.eventList = eventList;
}

window.onEventFilterChanged = () => {
    hideEventList();
    setTimeout(function () {
        resetFilters();
        getSelectedFilters();
        applySelectedFilters();
        if (window.$eventFilterTime.val() === 'current') {
            sortEventsByTimeStartAsc();
        } else if (window.$eventFilterTime.val() === 'archive') {
            sortEventsByTimeEndDesc();
        }
        setEvenOddClasses();
        showEventList();
    }, 200);
}

window.hideEventList = () => {
    window.$eventListWrapper.fadeOut(200);
}

window.resetFilters = () => {
    $.each(window.eventList, function () {
        this.ref.hide();
    });

    window.eventFilterTimeValue = null;
    window.eventFilterCalendarValue = null;
}

window.getSelectedFilters = () => {
    window.eventFilterTimeValue = {
        from: parseInt(window.$eventFilterTime.find(':selected').data('time-from')) || null,
        till: parseInt(window.$eventFilterTime.find(':selected').data('time-till')) || null
    };

    if (window.$eventFilterCalendar.val() !== "0") {
        window.eventFilterCalendarValue = parseInt($eventFilterCalendar.val());
    }
}

window.applySelectedFilters = () => {
    $.each(window.eventList, function () {
        if (window.eventFilterTimeValue !== null) {
            if (this.timeEnd <= window.eventFilterTimeValue.from ||
                (window.eventFilterTimeValue.till && this.timeEnd >= window.eventFilterTimeValue.till)) {
                return true;
            }
        }

        if (window.eventFilterCalendarValue !== null) {
            if (window.eventFilterCalendarValue !== this.calendar) {
                return true;
            }
        }
        this.ref.show();
    });
}

window.sortEventsByTimeStartAsc = () => {
    var list = [];
    $.each(window.eventList, function () {
        list.push(this.timeStart);
    });
    list.sort();
    $.each(list, function () {
        var listItem = parseInt(this);
        $.each(window.eventList, function () {
            var eventItem = this;
            if (eventItem.timeStart === listItem) {
                eventItem.ref.appendTo(window.$eventListWrapper);
            }
        });
    });
}

window.sortEventsByTimeEndDesc = () => {
    var list = [];
    $.each(window.eventList, function () {
        list.push(this.timeEnd);
    });
    list.sort();
    list.reverse();
    $.each(list, function () {
        var listItem = parseInt(this);
        $.each(window.eventList, function () {
            var eventItem = this;
            if (eventItem.timeEnd === listItem) {
                eventItem.ref.appendTo(window.$eventListWrapper);
            }
        });
    });
}

window.setEvenOddClasses = () => {
    var i = 0;
    $.each($eventListWrapper.find('.event'), function () {
        $(this).removeClass('even odd last first');
        if ($(this).css('display') !== 'none') {
            if (i % 2) {
                $(this).addClass('odd');
            } else {
                $(this).addClass('even');
            }
            i++;
        }
    });
}

window.showEventList = () => {
    window.$eventListWrapper.fadeIn(200);
}

$(document).ready(() => {
    var $slider = $('.slick-slider'),
        $scrollToTopBtn = $('#scroll-to-top-btn');

    /**
     * load facebook sdk
     * init facebook app
     */
    // $.getScript('//connect.facebook.net/en_US/sdk.js', function () {
    //     FB.init({
    //         //     appId: '{your-app-id}',
    //         version: 'v2.7'
    //     });
    // });

    /**
     * bind slick slider events
     */
    $slider.on('init', function (slick) {
        // change the order of the elements for easier styling
        var slides = $(this).find('.slick-slide');
        $.each(slides, function () {
            var imageContainer = $(this).find('.image_container');
            $(this).prepend(imageContainer);
        });
    });

    /**
     * init slick slider
     */
    $slider.slick({
        dots: true,
        autoplaySpeed: 3000,
        arrows: true,
        infinite: true,
        adaptiveHeight: true
    });

    bindNavigationEvents();
    moveSocialShareToBottomOfParentElement();
    initEventFilters();

    /**
     * bind resize event
     */
    $(window).on('resize', debounce(50, onResize));
    $(window).trigger('resize');

    /**
     * bind scroll event
     */
    $(document).on('scroll', function () {
        onDocumentScroll();
    });

    /**
     * bind click event for scrollToTopBtn
     */
    $scrollToTopBtn.on('click', function () {
        onScrollToTopBtnClicked();
    });

    /**
     * bind social share events
     */
    // $('#facebook-share-btn').on('click', function (event) {
    //     event.preventDefault();
    //
    //     FB.ui({
    //         method: 'share',
    //         display: 'popup',
    //         href: $(this).data('href')
    //     }, function (response) {
    //     });
    // });

    /**
     * Lightbox for images on page
     */
    const lightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        openEffect: 'fade',
        closeEffect: 'fade',
        skin: 'custom-style',
    });


    /**
     *  Toggles expandable text in '.exhibition-intro__text__paragraph'
     */
    document.querySelectorAll('.expand-wrapper').forEach(expandWrapper => {
        const expandBtn = expandWrapper.querySelector('.expand-btn');
        const expandContainer = expandWrapper.querySelector('.expand-container');
        const expandText = expandWrapper.querySelector('.expand-text');
        const newHeight = expandText.offsetHeight + 50 + 'px';
        const oldHeight = expandContainer.offsetHeight + 'px';

        expandBtn.addEventListener('click', () => {
            if (expandBtn.dataset.expanded === 'true') {
                expandBtn.dataset.expanded = 'false';
                expandBtn.classList.remove('exhibition-intro__button--expanded');
                expandContainer.style.height = oldHeight;
                expandBtn.getElementsByTagName('strong')[0].innerText = 'Mehr';
                expandWrapper.scrollIntoView({behavior: "smooth"});
            } else {
                expandBtn.dataset.expanded = 'true';
                expandBtn.classList.add('exhibition-intro__button--expanded');
                expandContainer.style.height = newHeight;
                expandBtn.getElementsByTagName('strong')[0].innerText = 'Weniger';
            }
        });
    });
});

function initComponents() {
    new ConsentManagement();
    new ExhibitionSlider();
}

initComponents();
